import { formatDate } from "presentation/utils/formatEndDate";
import { Dependent } from "../../domain/entities/dependent";
import { Message } from "../../domain/entities/message";
import { DependentInputFilter } from "../../domain/contracts/dependent.contract";
import { httpClient } from "../axios/axios-api";

class DependentRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/dependent/${id}`);
    return response.data;
  }

  async create(input: Dependent): Promise<Message<Dependent>> {
    let birthDate = formatDate(input.birthDate);
    input = {
      ...input,
      birthDate: birthDate,
      employee: {
        id: input.employeeId || input.employee?.id || ""
      }
    }

    const response = await httpClient.post(`/dependent`, { data: input });
    return response.data;
  }

  async update(input: Dependent): Promise<Message<boolean>> {
    let birthDate = formatDate(input.birthDate);
    input = {
      ...input,
      birthDate: birthDate,
      employee: {
        id: input.employeeId || input.employee?.id || ""
      }
    }

    const response = await httpClient.put(`/dependent/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: DependentInputFilter): Promise<Message<Dependent[]>> {
    const response = await httpClient.get(`/dependents`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Dependent>> {
    const response = await httpClient.get(`/dependent/${id}`);
    return response.data;
  }
}

export default new DependentRepository();
